import {Slider} from '../index'
import {useEffect, useState} from "react";
import {getSplash} from "../../services/services";
import {Link} from "react-router-dom";

const Topbox = () => {

    const [data,setData] = useState(false)

    const getData = async () => {
        const response = await getSplash()
        if (response && response.data.code == 1) {
            setData(response.data)
        } else {
            alert('مشکل در ارتباط با سرور')
        }
    }


    useEffect(() => {

        getData()
    }, []);

    return (
        <>


            <div className='columns m-0 is-multiline    '>

                <div className='column is-12  h100' style={{
                    backgroundImage: `url('/images/bg1.webp')`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',

                }}>

                    <div className='columns m-0  is-flex flex-JCS-ACS ' style={{
                        height: '100%',
                    }}>

                        <div className='column is-6 is-hidden-mobile'>


                        </div>


                        <div className='column is-6 has-text-centered has-text-white p-3  '>

                            <span className='is-size-3 clrtwotext'>
                              {
                                  data &&
                                  data.options.footer_blue
                              }
                            </span>
                            <h1 className='is-size-1'>
                                {  data && data.options.h1}
                            </h1>
                            <h2 className='has-text-white is-size-2'>
                                {data && data.options.subtitle}
                            </h2>
                            <p className='is-size-4 has-text-justified'>
                                {  data && data.options.about}
                            </p>

                            <Link to='/products'>
                                <button className='button clrtwo has-text-white  is-size-5 m-3'>
                                    محصولات

                                </button>
                            </Link>


                            <Link to='/contact'>
                                <button className='button mybutton is-size-5 m-3'>
                                    ارتباط با ما

                                </button>

                            </Link>



                        </div>


                    </div>


                </div>


                <div className='column is-12 p-4 mt-5 '>

                    <div className='columns m-0   clrthree clrtwoborder borderrad1 '>

                        <div className='column is-6 has-text-centered'>
                            <img src="/icons/logo-wh.png" alt="logo" style={{
                                maxWidth: '20rem',
                            }}/>
                        </div>

                        <div className='column is-6'>
                          <div className='columns m-0  ' >
                              <div className='column has-text-centered has-text-white is-3 borderleft1 '>
                                  <img src="/icons/quality.png" alt=""/>

                               <p className='is-size-3 clrtwotext has-text-weight-bold'>
                                  100%
                               </p>

                                  <p>
                                    رضایت مشتریان
                                  </p>

                              </div>

                              <div className='column has-text-centered has-text-white is-3 borderleft1'>
                                  <img src="/icons/cargo.png" alt=""/>

                                  <p className='is-size-3 clrtwotext has-text-weight-bold'>
                                    500+
                                  </p>

                                  <p>
                                     ترخیض کالا
                                  </p>

                              </div>

                              <div className='column has-text-centered has-text-white is-3 borderleft1'>
                                  <img src="/icons/hand.png" alt=""/>

                                  <p className='is-size-3 clrtwotext has-text-weight-bold'>
                                      3+
                                  </p>

                                  <p>
                                      سابقه فعالیت
                                  </p>

                              </div>

                              <div className='column has-text-centered has-text-white is-3'>
                                  <img src="/icons/world.png" alt=""/>

                                  <p className='is-size-3 clrtwotext has-text-weight-bold'>
                                    80+
                                  </p>

                                  <p>
                                    مشتری فعال
                                  </p>

                              </div>
                          </div>
                        </div>

                    </div>

                </div>


                <div className='column is-12'>
                    <Slider/>

                </div>


            </div>


        </>
    )
}

export default Topbox;